import React, { useEffect, useState } from "react";
import { Form, Spinner, Table } from "react-bootstrap";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { useParams } from "react-router";
import SplitPane from "react-split-pane";
import { studyDatasetsServices } from "../../../../APIServices/studyDatasetsServices";
import Swal from "sweetalert2";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const DatasetsList = ({ onMouseDown, tableRef, transferId }) => {
  const [datasetsList, setDatasetsList] = useState([]);
  const [datasets, setDatasets] = useState([]);
  const [loading, setLoading] = useState(false);
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [buttonLoader, setButtonLoader] = useState(false);
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();

  const getStudyLevelForm = async (e) => {
    setLoading(true);
    let data = await studyLevelFormManagementServices.getStudyLevelForm(
      studyId,
      LoginCat,
      "active",
      StudyMode
    );
    setDatasetsList(data?.data || []);
    setLoading(false);
  };

  const updateStudyDatasetTransfer = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Datasets!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {}
        userData.transferId = transferId
        userData.datasets = datasets
        userData.studyId = studyId
        userData.mode = StudyMode
        userData.type = "datasets"
        let data = await studyDatasetsServices.updateStudyDatasetTransfer(userData);
        if (data?.statusCode === 200) {
          getSingleDataTransferedInfo();
        }
      }
      setButtonLoader(false);
    });
  };

  const handleChangeCheckbox = (formId) => {
    setDatasets((prevSelected) => {
      if (prevSelected.includes(formId)) {
        return prevSelected.filter((id) => id !== formId);
      } else {
        return [...prevSelected, formId];
      }
    });
  };

  const handleSelectAll = () => {
    if (datasets?.length === datasetsList.length) {
      setDatasets([]);
    } else {
      const allFormIds = datasetsList.map((item) => item.formId);
      setDatasets(allFormIds);
    }
  };

  const getSingleDataTransferedInfo = async (e) => {
    let data = await studyDatasetsServices.getSingleDataTransferedInfo(
      studyId,
      transferId,
      "datasets"
    );
    setDatasets(data?.data?.datasets || []);
  };

  useEffect(() => {
    if (transferId) {
      getSingleDataTransferedInfo();
    }
  }, [transferId]);

  useEffect(() => {
    getStudyLevelForm();
  }, []);

  return (
    <>
      <SplitPane
        split="vertical"
        minSize={"100%"}
        style={{ height: "-webkit-fill-available" }}
      >
        {loading ? (
          <PageLoader/>
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    style={{ width: 45 }}
                    className="text-center"
                  >
                    <Form.Check
                      checked={datasets?.length === datasetsList.length && datasetsList.length > 0}
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 1)}>Datasets</th>
                  <th onMouseDown={(e) => onMouseDown(e, 2)}>Datasets Code</th>
                </tr>
              </thead>
              <tbody>
                {datasetsList.map((data, index) => (
                  <tr className="CP" key={index}>
                    <td className="text-center">
                      <Form.Check
                        checked={datasets?.includes(data.formId)}
                        onChange={() => handleChangeCheckbox(data.formId)}
                      />
                    </td>
                    <td>{data?.formName}</td>
                    <td>{data?.formCode}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="text-end position-sticky bottom-0 p-2 bg-white">
              <button
                onClick={updateStudyDatasetTransfer}
                className="updateProfile">
                {buttonLoader ? (
                  <div className="hstack gap-2">
                    <Spinner size="sm"/> Updating...
                  </div>
                ) : (
                  "Update Datasets"
                )}
              </button>
            </div>
          </>
        )}
      </SplitPane>
    </>
  );
};

export default DatasetsList;
